export default {"src":"/_next/static/media/star.27c0e429.svg","height":10,"width":11,"blurWidth":0,"blurHeight":0};